module.exports = __webpack_public_path__ + "static/media/DSC00173.46945537.jpg";